import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=8025eca2&scoped=true&"
import script from "./form.component.vue?vue&type=script&lang=ts&"
export * from "./form.component.vue?vue&type=script&lang=ts&"
import style0 from "./form.component.vue?vue&type=style&index=0&id=8025eca2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025eca2",
  null
  
)

export default component.exports